import instance from './interceptor';

export const auth = {
  login: async ({ payload }) => instance.post('auth/login', payload),
  register: async ({ payload }) => instance.post('auth/register', payload),
  verfication: async () => instance.post('email/verification-notification'),
  logout: async () => instance.post('auth/logout'),
};
